import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { deactivateColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getDeactivate } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "status", "last_updated"];

const SparqDeactivateBatch = () => (
  <BatchDetail
    title="Sparq Deactivate"
    apiGet={__getDeactivate}
    client={CLIENTS.sparq}
    columnsFactory={(ctx) => deactivateColumns({ ...ctx, iccidHeaderName: "ICCID" })}
    copyKeys={COPY_KEYS}
    exportAction="deactivate"
    retryOperation="deactivate"
    showTerminate
    getRowPath={(row) => `/sparq/deactivate/${row.id}`}
  />
);

export default SparqDeactivateBatch;
